module.exports = __webpack_public_path__ + "static/media/flag-china.ecd2e221.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-china.svg
// module id = 1125
// module chunks = 1